export const localizeValue = (min: number, max: number, input?: number) => {
  if (typeof input !== "number") return max - min;
  const minLog = Math.log(min);
  const maxLog = Math.log(max);
  const scale = (maxLog - minLog) / 100;
  const calc = (value: number) => (Math.log(Number(value)) - minLog) / scale;
  return Number(calc(input).toFixed(2));
};

export const exponentiateValue = (min: number, max: number, input?: number) => {
  if (typeof input !== "number") return max - min;
  const minLog = Math.log(min);
  const maxLog = Math.log(max);
  const scale = (maxLog - minLog) / 100;
  const calc = (value: number) =>
    Math.floor(Math.exp(Number(value) * scale + minLog));
  return Math.max(min, Math.min(max, calc(input)));
};

export const localizeValues = (input: number[], min: number, max: number) =>
  input.map((v) => localizeValue(min, max, v));

export const exponentiateValues = (input: number[], min: number, max: number) =>
  input.map((v) => exponentiateValue(min, max, v));
